module.exports = __webpack_public_path__ + "static/media/CBreitbach_CV_2023.8a9d19f0.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/CBreitbach_CV_2023.pdf
// module id = 132
// module chunks = 0